<template>
    <div>
        <input
            type="hidden"
            name="flexChannels"
            :value="selectedChannels"
        >

        <div class="flex items-center text-sm font-semibold">
            <div class="w-full lg:w-1/2">
                {{ lang('Välj flex-kanaler','Select flex channels') }}
            </div>
            <div class="flex items-center w-full lg:w-1/2 relative">
                <div>
                    {{ selectedChannels.length }}/{{ maxFlexChannels }} {{ lang('valda','selected') }}
                </div>
                <a
                    :class="{ 'is-active' : toggled }"
                    class="absolute pin-t pin-r text-neutral-darker"
                    @click="toggle"
                >
                    <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                </a>
            </div>
        </div>

        <div v-if="toggled" class="text-sm text-neutral-dark mt-2xl mb-lg md:mb-xl">
            <h4>{{ lang('TV-kanaler','TV channels') }}</h4>
            <div class="flex flex-wrap channels max-w-xl">
                <option-box-checkbox
                    v-for="channel in sdChannels"
                    :key="channel.id"
                    v-model="selectedChannels"
                    :value="channel.ataio_id"
                    additional-class="channel with-checkbox"
                    :disabled="channelIsDisabled(channel)"
                >
                    <div>
                        <div
                            v-tooltip.top="channel.name"
                            class="image"
                        >
                            <img :src="channel.image" :alt="channel.name">
                        </div>
                        <div v-if="channel.title" class="text-xs font-semibold mt-sm">
                            {{ channel.title }}
                        </div>
                        <div v-if="channel.title" class="text-sm text-neutral-dark">
                            {{ channel.price }}
                        </div>
                    </div>
                </option-box-checkbox>
            </div>

            <h4 class="mt-lg">{{ lang('HD-kanaler','HD channels') }}</h4>
            <div class="flex flex-wrap channels max-w-xl">
                <option-box-checkbox
                    v-for="channel in hdChannels"
                    :key="channel.id"
                    v-model="selectedChannels"
                    :value="channel.ataio_id"
                    additional-class="channel with-checkbox"
                    :disabled="channelIsDisabled(channel)"
                >
                    <div>
                        <div
                            v-tooltip.top="channel.name"
                            class="image"
                        >
                            <img :src="channel.image" :alt="channel.name">
                        </div>
                        <div v-if="channel.title" class="text-xs font-semibold mt-sm">
                            {{ channel.title }}
                        </div>
                        <div v-if="channel.title" class="text-sm text-neutral-dark">
                            {{ channel.price }}
                        </div>
                    </div>
                </option-box-checkbox>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            channels: {
                required: true,
                type: Array,
            },
            maxFlexChannels: {
                type: Number,
                default: 8,
            },
        },
        data() {
            return {
                toggled: false,
                selectedChannels: [],
            };
        },
        computed: {
            sdChannels() {
                return this.channels.filter((channel) => ! channel.pivot.is_hd);
            },
            hdChannels() {
                return this.channels.filter((channel) => channel.pivot.is_hd);
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
            channelIsDisabled(channel) {
                const found = this.selectedChannels.indexOf(channel.name);

                if (found !== -1) {
                    return false;
                }

                return this.selectedChannels.length >= this.maxFlexChannels;
            },
        },
    };
</script>